import {BaseConfig} from "../../infrastructure/config/base-config";
import {GamesSliderWidgetTerms} from "./games-slider-widget.terms";

export class GamesSliderWidgetConfig extends BaseConfig {

  static injectables = [GamesSliderWidgetTerms];

  constructor(terms: GamesSliderWidgetTerms) {
    super('games-slider-widget', null, terms);
  }
}

